import type { ImpactReportView } from 'v2/interfaces/impactMeter';

const compactFormatter = new Intl.NumberFormat('pt-BR', {
  notation: 'compact',
  compactDisplay: 'short',
  maximumFractionDigits: 0
});

const integerFormatter = new Intl.NumberFormat('pt-BR');

function formatUnit(value: number, singular: string, plural: string) {
  return `${value} ${value === 1 ? singular : plural}`;
}

export function formatCompactImpact(value: number) {
  return compactFormatter.format(value);
}

export function formatIntegerImpact(value: number) {
  return integerFormatter.format(value);
}

export function formatLast30Days(value: number) {
  const formatted = formatIntegerImpact(value);
  return value > 0 ? `+${formatted}` : formatted;
}

export function formatJourney({
  yearsAtEduzz,
  monthsAtEduzz,
  daysAtEduzz
}: Pick<ImpactReportView, 'yearsAtEduzz' | 'monthsAtEduzz' | 'daysAtEduzz'>) {
  if (yearsAtEduzz >= 1) {
    return formatUnit(yearsAtEduzz, 'ano', 'anos');
  }

  if (monthsAtEduzz >= 1) {
    return formatUnit(monthsAtEduzz, 'mês', 'meses');
  }

  return formatUnit(daysAtEduzz, 'dia', 'dias');
}
